// English language pack
// Note: All keys are in Simplified Chinese, values are in English
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Available',
    '质押金额': 'Principal',
    '技术模块': 'Agri Wealth',
    '理财说明': 'Daily-return products credit interest to your available balance every day while principal stays locked. Maturity-return products pay all interest once at redeem or expiry.',
    '全部产品': 'All',
    '日反': 'Daily return',
    '到期反': 'At maturity',
    '日预计': 'Est. daily',
    '到期预计': 'Est. at maturity',
    '暂无该类型产品': 'No products in this category',
    '日利率': 'Daily rate',
    '算力周期': 'Computing Period',
    '天': 'Days',
    '算力类型': 'Computing Type',
    '基础算力': 'Basic Computing',
    '高级算力': 'Advanced Computing',
    '超级算力': 'Super Computing',
    '企业算力': 'Enterprise Computing',
    '垂直种植系统': 'Vertical Farming System',
    '无土栽培': 'Soilless Cultivation',
    'LED人工光': 'LED Artificial Light',
    'AI环境控制': 'AI Environment Control',
    '精准灌溉/营养液': 'Precision Irrigation / Nutrients',
    '传感器+数据系统': 'Sensors + Data Systems',
    '自动化生产': 'Automated Production',
    '植物算法/育种': 'Plant Algorithms / Breeding',
    '高性能': 'High Performance',
    '标准': 'Standard',
    '经济型': 'Economy',
    '申请算力': 'Apply for Computing Power',
    '可申请次数': 'Available Applications',
    '剩余次数': 'Remaining Times',
    '短算力类型': 'Type',
    '短算力周期': 'Period',
    '短预计日收益': 'Daily',
    '短剩余次数': 'Left',
    '短解押记录': 'Redeem',
    '短算力记录': 'Subscriptions',
    '短质押明细': 'Holdings',
    '短待审': 'Pending',
    '短成功': 'Done',
    '短失败': 'Fail',
    '短完成': 'Ended',
    '超级算力申请': 'Join Plan',

    '步骤提示租赁': 'Step 1 Choose a tech module · Step 2 Tap Join Plan',
    '请选择算力方案': 'Select a wealth product',
    '请先选择算力方案': 'Select a hashrate plan before tapping hashrate leasing',    '算力收益等级': 'Computing Rate Tiers',
    '查看算力收益等级': 'View Computing Rate Tiers',
    '暂无高级算力等级数据': 'No advanced computing tier data available',
    '暂无超级算力等级数据': 'No super computing tier data available',

    // Computing Application Detail Page
    '算力详情': 'Computing Details',
    '基本信息': 'Basic Information',
    '原押金额': 'Original Stake Amount',
    '每日收益记录': 'Daily Earnings Records',
    '暂无数据': 'No Data Available',

    // Computing details
    '算力类型标签': 'Computing Type:',
    '算力周期标签': 'Computing Period:',
    '算力类型：': 'Computing Type:',
    '算力周期：': 'Computing Period:',
    '预计收益：': 'Expected Earnings:',
    '质押要求：': 'Staking Requirement:',
    '开始时间：': 'Start Time:',
    '结束时间：': 'End Time:',
    '立即申请': 'Apply Now',
    
    // Status and prompts
    '申请中': 'Applying...',
    '申请成功': 'Application Successful',
    '申请失败': 'Application Failed',
    '申请失败，请重试': 'Application failed, please try again',
    '余额不足': 'Insufficient Balance',
    '请先连接钱包': 'Please Connect Wallet First',
    '算力申请成功': 'Computing Power Application Successful!',
    '算力申请失败，请重试': 'Computing Power Application Failed, Please Try Again',
    '申请失败，请先解押已完成的算力订单': 'Application failed, please unstake the completed computing power order first',
    'USDC': 'USDC',
    
    // Confirmation dialog
    '确认申请': 'Confirm Application',
    '取消': 'Cancel',
    '确认': 'Confirm',
    '您确定要申请此算力吗': 'Are you sure you want to apply for this computing power?',
    '您确定要申请此算力吗？': 'Are you sure you want to apply for this computing power?',
    '申请后将扣除相应的质押金额': 'The corresponding staking amount will be deducted after application',
    
    // Computing status
    '运行中': 'Running',
    '已完成': 'Completed',
    '待开始': 'Pending',
    '已取消': 'Cancelled',
    
    // Earnings related
    '预计日收益': 'Expected Daily Earnings',
    '总预计收益': 'Total Expected Earnings',
    '当前收益': 'Current Earnings',
    
    // Records and status
    '解押申请记录': 'Redemption Records',
    '超级算力申请记录': 'Super Computing Power Application Records',
    '解压入口': 'Unstake Portal',
    '申请解押': 'Hashrate Redemption',
    '暂无可解压的申请': 'No redeemable applications',
    '申请时间': 'Application Time',
    '到期时间': 'Expiry Time',
    '可解压': 'Redeemable',
    '确认解压': 'Confirm Redemption',
    '解压确认': 'Redemption Confirmation',
    '解压成功': 'Redemption Successful',
    '解压失败': 'Redemption Failed',
    '资金已返回到您的账户': 'Funds have been returned to your account',
    '网络错误，请重试': 'Network error, please try again',
    '全部': 'All',
    '待审核': 'Pending',
    '成功': 'Success',
    '失败': 'Failed',
    '正在加载记录': 'Loading records...',
    '暂无记录': 'No records',
    '解押金额': 'Redemption Amount',
    '申请天数': 'Application Days',
    '金额': 'Amount',

    // Modal related
    '选择周期': 'Selected Period',
    '收益率': 'Yield Rate',
    '申请金额': 'Application Amount',
    '请输入申请金额': 'Please enter application amount',
    '最大可申请金额': 'Maximum applicable amount',
    '投入限额': 'Investment Limit',
    '最低投入': 'Minimum Investment',
    '最大投入': 'Maximum Investment',
    '短投入限额': 'Limit',
    '请输入有效的申请金额': 'Please enter a valid application amount',
    '申请金额不能低于最低投入': 'Application amount cannot be lower than the minimum investment',
    '申请金额不能高于最大投入': 'Application amount cannot exceed the maximum investment',

    // Error messages
    '网络错误，请稍后重试': 'Network error, please try again later',
    '参数错误': 'Parameter error',
    '服务器错误': 'Server error',
    '未知错误': 'Unknown error',
    '质押金额不足': 'Insufficient staked amount',
    '解押金额不能超过当前质押金额': 'Unstaking amount cannot exceed current staked amount',
    '需要连接钱包才能申请算力': 'Need to connect wallet to apply for computing power',
    '需要连接钱包才能申请解押': 'Need to connect wallet to apply for unstaking',
    '请输入有效金额': 'Please enter a valid amount',
    '请输入大于0的解押金额': 'Please enter an unstaking amount greater than 0',
    '申请提交成功': 'Application submitted successfully!',
    '您的解押申请已提交，请等待审核': 'Your redemption request has been submitted, please wait for review',
    '申请提交失败': 'Application submission failed',
    '请稍后重试': 'Please try again later',
    '您的账户余额不足，无法申请算力': 'Your account balance is insufficient to apply for computing power',
    '您的算力申请已提交，请等待审核': 'Your computing power application has been submitted, please wait for review',
    '登录已过期': 'Login expired',
    '请重新连接钱包': 'Please reconnect wallet',
    '加载失败': 'Loading failed',
    '无法获取解押申请记录': 'Unable to get unstaking application records',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'You have a pending application, please wait for review to complete before submitting a new application',
    '您还有未解押的算力订单，无法申请新的算力': 'You have an unstaked computing power order, unable to apply for new computing power',
    '申请次数已用完，最大申请次数': 'Application limit reached, maximum applications',
    '没有可解押的金额': 'No amount available to unstake',
    '您已有待处理的解押申请，请等待审核': 'You already have a pending unstaking request, please wait for review',

    '我的算力订单': 'My Hashrate Orders',
    '总质押': 'Total Staked',
    '总收益': 'Total Earned',
    '进行中': 'Active',
    '剩余天数': 'Remaining',
    '暂无算力订单': 'No hashrate orders',

    // Wallet connection related popups
    '钱包未连接': 'Wallet not connected',
    '钱包信息错误': 'Wallet information error',
    '钱包地址无效': 'Invalid wallet address',
    '授权已失效': 'Authorization expired',
    '授权检查失败': 'Authorization check failed',
    '请重新授权USDC后再进行投资': 'Please re-authorize USDC before investing',
    '请稍后重试或重新连接钱包': 'Please try again later or reconnect wallet',
    '断开连接': 'Disconnect',

    // Status text mapping
    '状态待审核': 'Pending',
    '状态成功': 'Success',
    '状态失败': 'Failed',
    '状态进行中': 'In Progress',
    '状态已完成': 'Completed',
    '状态已取消': 'Cancelled',
    '状态未知': 'Unknown',

    // Wallet address related
    '未连接钱包': 'Wallet not connected',
    '地址格式错误': 'Invalid address format',

    // Customer service
    '客服功能开发中，敬请期待': 'Customer service is under development, please stay tuned!',

    // Computing settings related
    '设置错误': 'Settings error',
    '未找到对应的算力设置': 'Computing settings not found',
    '无法获取算力设置': 'Unable to get computing settings',

    // Unstake related (new)
    '解押审核中': 'Unstake Under Review',
    '已解押': 'Unstaked',
    '确认解押': 'Confirm Unstake',
    '处理中': 'Processing...',
    '解押申请已提交': 'Unstake Application Submitted',
    '请等待审核处理': 'Please wait for review',
    '解押申请失败': 'Unstake Application Failed',
    '当前状态不允许解押': 'Current status does not allow unstaking',

    // Stake details related (new)
    '质押明细': 'Hashrate Details',
    '后值': 'After Value',
    '管理员操作': 'System Operation',
    '暂无质押记录': 'No hashrate records',
    '正在加载质押记录': 'Loading hashrate records...',
    '获取质押记录失败': 'Failed to get hashrate records',
    '收益': 'Earnings',
    '质押': 'Hashrate',
    '解押': 'Redeem',
    '充值': 'Deposit',
    '提现': 'Withdraw',
    '奖励': 'Reward',
    '推荐奖励': 'Referral Reward',
    '系统调整': 'System Adjustment',
    '算力收益': 'Computing Earnings',
    '机器人收益': 'Bot Earnings',

    // Loading and error messages (new)
    '无法获取申请详情': 'Unable to get application details',
    '请检查网络连接后重试': 'Please check network connection and try again',
    '未找到可解押的算力申请': 'No unstakeable computing applications found',

    // Status related (new)

    // Detail page related (new)
    '算力申请详情': 'Computing Application Details',
    '算力申请记录': 'Computing Application Records',
    '正在加载详情': 'Loading details...',
    '申请周期': 'Application Period',
    '累计收益': 'Total Earnings',
    '暂无收益记录': 'No earnings records',
    '加载失败请重试': 'Loading failed, please retry',
    '重新加载': 'Reload',
    '包含累计收益': 'including total earnings',
    '解押后资金将退回到平台资产中不再产生收益': 'After unstaking, funds will be returned to platform assets and will no longer generate earnings.',
    '申请赎回': 'Redeem',
    '赎回金额': 'Redeem Amount',
    '赎回审核中': 'Redemption Under Review',
    '可赎回': 'Redeemable',
    '已到期': 'Matured',
    '未到期': 'Running',
    '暂无可赎回算力': 'No redeemable hashrate orders',
    '未到期不可赎回': 'Cannot redeem before maturity',
    '暂不可赎回': 'Not Redeemable Yet',
    '当前算力未到期': 'Current hashrate has not matured, redemption available after maturity',
    '需要连接钱包才能申请赎回': 'Need to connect wallet to apply for redemption',
    '您的赎回申请已提交，请等待审核': 'Your redemption request has been submitted, please wait for review',
    '确认赎回': 'Confirm Redemption',
    '已赎回': 'Redeemed',
    '您已有待处理的赎回申请，请等待审核': 'You already have a pending redemption request, please wait for review',
    '当前状态不允许赎回': 'Current status does not allow redemption',
    '没有可赎回的金额': 'No redeemable amount available'
  },

  wealth: {
    '理财资产': 'Wealth assets',
    '理财产品': 'Wealth product',
    '我的持仓': 'My positions',
    '持仓标题': 'Positions',
    '持仓详情': 'Position detail',
    '累计收益': 'Total earnings',
    '今日收益': 'Today',
    '全部': 'All',
    '活期': 'Flexible',
    '定期': 'Fixed',
    '日反': 'Daily',
    '到期反': 'At maturity',
    '日利率': 'Daily rate',
    '订单号': 'Order',
    '含加息': 'Boost',
    '起投': 'Min',
    '最高': 'Max',
    '天': 'd',
    '期限': 'Term',
    '随时赎回': 'Redeem anytime',
    '加载中': 'Loading',
    '暂无产品': 'No products',
    '产品规则': 'Rules',
    '规则日反': 'Daily return: interest is credited to your available balance every day.',
    '规则到期反': 'At-maturity return: no daily interest; principal and interest settle at expiry.',
    '规则活期赎回': 'Flexible principal can be redeemed anytime. No interest on the redeem day.',
    '规则可提前': 'Early redeem allowed. Penalty',
    '规则不可提前': 'No early redeem. Principal and interest return automatically at expiry.',
    '申购金额': 'Amount',
    '预计日收益': 'Est. daily',
    '到期总收益': 'Est. at maturity',
    '可用余额': 'Available',
    '立即申购': 'Subscribe now',
    '申购中': 'Subscribing...',
    '申购失败': 'Subscribe failed',
    '进行中': 'Active',
    '已结束': 'Closed',
    '暂无持仓': 'No positions',
    '本金': 'Principal',
    '已获收益': 'Earned',
    '剩余天数': 'Left',
    '可赎回': 'Redeemable',
    '已到期': 'Matured',
    '已赎回': 'Redeemed',
    '提前赎回': 'Early redeem',
    '每24小时': 'Every 24h',
    '状态': 'Status',
    '收益流水': 'Earnings',
    '暂无收益': 'No earnings yet',
    '赎回预览': 'Redeem preview',
    '退回本金': 'Principal back',
    '罚息': 'Penalty',
    '到期利息': 'Maturity interest',
    '没收未结利息': 'Unpaid interest forfeited',
    '立即赎回': 'Redeem now',
    '赎回中': 'Redeeming...',
    '赎回失败': 'Redeem failed',
    '市场': 'Markets',
    '产品介绍': 'About this product',
    '交易区': 'Subscribe',
    '行情': 'Quote',
    '年化参考': 'Est. APY',
    '付息': 'Payout',
    '赎回规则': 'Redeem',
    '产品代码': 'Pair',
    '全部买入': 'Max',
    '市场说明': 'Interest is calculated on the daily rate. Daily payout credits interest each day; at-maturity payout settles principal and interest at expiry. Some products allow early redeem.',
    'VIP等级': 'VIP',
    '限购次数': 'Purchase limit',
    '剩余次数': '{n}/{max} left',
    '限购详情': '{used}/{max} used, {remaining} left',
    '等级未解锁': 'Unlock with {current}/{required} {tier}',
    '等级未开放': 'Tier locked',
    '已达限购': 'Purchase limit reached',
    '使用加息卡': 'Use boost cards (optional)',
    '已选加息卡': '{n}/{max} selected',
    '暂无待用加息卡': 'No boost cards. Redeem from Farm.',
    '加息后日利率': 'Boosted daily rate'
  },

  // ==================== Assets Page - Assets.vue ====================
  assets: {
    // Total assets
    '总资产': 'Total Assets',
    '理财持仓': 'Wealth holding',
    '理财资产': 'Wealth Assets',
    '今日理财收益': 'Today',
    '我的余额(元)': 'My Balance (Yuan)',

    // Income overview
    '总收入': 'Total Income',
    '今日收入': 'Today\'s Income',
    '今日收益': 'Today\'s Earnings',
    '昨日收益': 'Yesterday\'s Earnings',
    '体验金': 'Demo Balance',
    '空投奖励': 'Airdrop Rewards',

    // Action buttons
    '充值': 'Deposit',
    '快速充值说明': 'Multi-coin deposit',
    '提现': 'Withdraw',
    '闪兑': 'Swap',
    '我的资产': 'My Assets',
    '邀请': 'Invite',
    '白皮书': 'Whitepaper',
    '幸运轮': 'Lucky Wheel',
    '站内信': 'Messages',
    '信用分': 'Credit Score',
    '快捷邀请': 'Invite',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Lucky',
    '快捷信用分': 'Credit',
    '选择充值币种': 'Select deposit coin',
    '自动到账': 'Auto credit',
    '人工审核': 'Manual review',
    '充值说明短': 'EVM coins credit automatically. Others need admin review after you submit Tx.',
    '手动充值': 'Manual Deposit',
    '可选协议': 'Networks',
    '选择协议': 'Select network',
    '闪兑标题': 'Flash Swap',
    '收款地址': 'Deposit address',
    '提交审核': 'Submit for review',
    '交易哈希': 'Transaction hash',
    '凭证链接': 'Proof URL (optional)',
    '金额': 'Amount',
    '上传转账凭证': 'Upload payment proof',
    '点击上传图片': 'Tap to upload transfer screenshot',
    '支持JPGPNG': 'JPG / PNG, max 5MB',
    '手动充值提示': 'Transfer to the address first, then upload a screenshot and enter the amount for review.',
    '扫码转账': 'Scan to transfer',
    '请上传图片': 'Please upload an image',
    '图片过大': 'Image must be under 5MB',
    '上传成功': 'Uploaded',
    '上传失败': 'Upload failed',
    '提交中': 'Submitting…',
    // copy toast
    '已复制': 'Copied',
    '复制成功': 'Copied successfully',
    '提交成功等待审核': 'Submitted. Waiting for review.',
    '提交失败': 'Submit failed',
    '用户ID': 'User ID',
    '兑出': 'From',
    '兑入': 'To',
    '确认闪兑': 'Confirm Swap',
    '闪兑记录': 'Swap History',
    '暂无闪兑记录': 'No swap records yet',
    '不可与兑出兑入相同币种': 'Cannot match the other side',
    '兑出与兑入不能是相同币种': 'From and To must be different',
    '报价失败': 'Quote failed',
    '金额无效': 'Invalid amount',
    '兑入数量过小': 'Receive amount is too small',
    '闪兑失败': 'Swap failed',
    '闪兑成功': 'Swap successful',
    '复制地址': 'Copy',
    '暂无币种': 'No assets configured',

    // VIP Level
    'VIP等级': 'VIP Level',
    '暂无VIP等级数据': 'No VIP level data available',

    // My account
    '我的账户': 'My Account',
    '申请备用金': 'Apply for Reserve Fund',
    '身份认证': 'Identity Verification',
    '设置资金密码': 'Set Fund Password',
    '选择语言': 'Select Language',
    '英语': 'English',

    // Console log messages
    '钱包未连接，触发钱包连接': 'Wallet not connected, triggering wallet connection',
    '钱包地址无效，重新连接': 'Invalid wallet address, reconnecting',
    '钱包已连接，直接跳转到充值页面': 'Wallet connected, redirecting to deposit page',
    '检查授权状态失败': 'Failed to check authorization status',
    '白皮书功能': 'Whitepaper function',
    '检查资金密码状态失败': 'Failed to check fund password status',

    // API related logs
    'Token不存在，显示默认余额': 'Token does not exist, showing default balance',
    '调用API获取用户余额数据': 'Calling API to get user balance data...',
    '体验金加载成功': 'Demo balance loaded successfully',
    '总资产计算完成': 'Total assets calculation completed',
    '余额': 'Balance',
    '质押金额': 'Hashrate Amount',
    'API返回失败': 'API returned failure',
    '加载用户余额失败': 'Failed to load user balance',
    'Token不存在，显示默认收益': 'Token does not exist, showing default earnings',
    '调用API获取用户收益数据': 'Calling API to get user earnings data...',
    '收益数据加载成功': 'Earnings data loaded successfully',
    '收益API返回失败': 'Earnings API returned failure',
    '加载用户收益失败': 'Failed to load user earnings',
    '使用默认收益数据': 'Using default earnings data',
    '信用分加载成功': 'Credit score loaded successfully',

    // Language selection
    '中文（简体）': 'Chinese (Simplified)',

    // Airdrop rewards related
    '钱包地址': 'Wallet address',
    '调用API获取空投奖励数据': '🔍 Calling API to get airdrop reward data...',

    // Customer service related
    '打开客服': 'Open customer service',
    '客服功能开发中，敬请期待！': 'Customer service function is under development, please stay tuned!',

    // Page loading
    '资产页面已加载': 'Assets page loaded'
  },

  // ==================== Recharge Page - Recharge.vue ====================
  recharge: {
    // Page title and navigation
    '充值': 'Recharge',
    '返回': 'Back',
    '充值记录': 'Recharge History',

    // Step titles
    '选择金额': 'Select Amount',
    '确认订单': 'Confirm Order',
    '完成转账': 'Complete Transfer',

    // Amount input
    '请输入充值金额': 'Please enter recharge amount',
    '自定义': 'Custom',
    '最小充值金额': 'Minimum recharge amount',
    '最低': 'Min',
    '余额不足': 'Insufficient balance',
    '最小充值金额提示': 'Minimum 500 USDC',
    '最大充值金额': 'Maximum recharge amount',
    '下一步': 'Next',
    '上一步': 'Previous',
    '开通自动转入': 'Enable Auto Transfer',

    // Order information
    '订单信息': 'Order Information',
    '订单号': 'Order Number',
    '充值金额': 'Recharge Amount',
    '网络': 'Network',
    '代币': 'Token',
    '收款地址': 'Receiving Address',
    '创建订单': 'Create Order',
    '创建中': 'Creating...',

    // Wallet connection related
    '请先连接钱包': 'Please connect wallet first',
    '未检测到钱包地址，请先连接钱包': 'Wallet address not detected, please connect wallet first',

    // Balance related
    'USDC余额不足': 'Insufficient USDC balance! Current balance',
    '转账超时，请检查钱包或重试': 'Transfer timeout, please check wallet or retry',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Transfer successful but no transaction hash received, please provide transaction hash manually',
    '当前网络': 'Current Network',
    '请切换到以太坊主网或测试网': 'Please switch to Ethereum Mainnet or Testnet',
    '未知网络': 'Unknown network (Chain ID: {id})',
    '检测到Cronos网络': 'Cronos network detected (Chain ID: 25). Please switch to Ethereum Mainnet in your wallet, then refresh and try again.',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Please click the network settings in the upper right corner of the page, select Ethereum, and then recharge again.',
    '需要': 'Required',

    // Transfer steps
    '请使用钱包转账': 'Please use wallet to transfer',
    '转账地址': 'Transfer Address',
    '转账金额': 'Transfer Amount',
    '合约地址': 'Contract Address',
    '复制地址': 'Copy Address',
    '复制金额': 'Copy Amount',
    '开始转账': 'Start Transfer',
    '转账中': 'Transferring...',
    '重新转账': 'Retry Transfer',
    '查看详情': 'View Details',

    // Status information
    '等待转账': 'Waiting for Transfer',
    '转账状态中': 'Transferring',
    '确认中': 'Confirming',
    '转账成功': 'Transfer Successful',
    '转账失败': 'Transfer Failed',
    '交易哈希': 'Transaction Hash',
    '在区块链浏览器中查看': 'View on Blockchain Explorer',

    // Tips
    '请确保转账金额准确': 'Please ensure transfer amount is accurate',
    '请确保使用正确的网络': 'Please ensure using correct network',
    '转账完成后系统会自动确认': 'System will auto-confirm after transfer completion',
    '地址已复制': 'Address copied',
    '金额已复制': 'Amount copied',
    '复制失败': 'Copy failed',

    // Error messages
    '金额不能为空': 'Amount cannot be empty',
    '金额必须大于': 'Amount must be greater than',
    '金额不能超过': 'Amount cannot exceed',
    '创建订单失败': 'Failed to create order',
    '转账失败，请重试': 'Transfer failed, please retry',
    '网络错误，请检查连接': 'Network error, please check connection',

    // MetaMask related
    '网络检查通过': 'Network check passed',
    'USDC余额不足！当前余额': 'Insufficient USDC balance! Current balance: {balance} USDC, required: {amount} USDC',
    '余额检查通过': '✅ Balance check passed',
    '余额检查失败': 'Balance check failed',
    '开始执行转账...': '🚀 Starting transfer execution...',
    '请在MetaMask中确认交易': '⏳ Please confirm transaction in MetaMask',
    '最终交易哈希': '✅ Final transaction hash',
    '交易哈希已保存到数据库': '✅ Transaction hash saved to database',
    '保存哈希失败': '❌ Failed to save hash',
    '转账发送失败': '❌ Transfer sending failed',
    '交易哈希更新成功': '✅ Transaction hash updated successfully',
    '更新订单交易哈希失败': '❌ Failed to update order transaction hash',
    '启动交易监控，订单号': '🔄 Starting transaction monitoring, order number',
    '检查交易状态...': '🔍 Checking transaction status...',
    '订单状态响应': '📊 Order status response',
    '订单详情': '📋 Order details',
    '交易成功！': '✅ Transaction successful!',
    '交易失败！': '❌ Transaction failed!',
    '交易还在确认中，状态': '⏳ Transaction still confirming, status',
    'API响应失败': '❌ API response failed',
    '检查交易状态失败': 'Failed to check transaction status',
    '转账状态已重置': '🔄 Transfer status reset',

    // Customer service related
    '客服功能开发中，敬请期待！': 'Customer service function is under development, please stay tuned!',

    // Computing rate tiers related
    '查看算力收益等级': 'View Computing Rate Tiers',
    '算力收益等级': 'Computing Rate Tiers',
    '暂无算力收益等级数据': 'No computing rate tier data available',
    '获取算力收益等级失败': 'Failed to get computing rate tiers',
    '日收益率': 'Daily Rate'
  },

  // ==================== Recharge History Page - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Recharge History',
    '全部': 'All',
    '待支付': 'Pending Payment',
    '待审核': 'Pending Review',
    '确认中': 'Confirming',
    '成功': 'Success',
    '失败': 'Failed',
    '已完成': 'Completed',
    '已取消': 'Cancelled',
    '暂无记录': 'No records',
    '加载中': 'Loading...',
    '加载更多': 'Load More',
    '没有更多数据': 'No more data',
    '暂无充值记录': 'No recharge records',
    '立即充值': 'Recharge Now',
    '充值': 'Recharge',
    '订单号': 'Order Number',
    '筛选': 'Filter',
    '记录': 'Records',
    '总充值': 'Total Recharge',
    '刚刚': 'Just now',
    '分钟前': ' minutes ago',
    '小时前': ' hours ago'
  },

  // ==================== Recharge Detail Page - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Recharge Details',
    '加载中': 'Loading',
    '订单不存在或已删除': 'Order does not exist or has been deleted',
    '返回': 'Back',
    '订单信息': 'Order Information',
    '订单号': 'Order Number',
    '充值网络': 'Recharge Network',
    '订单状态': 'Order Status',
    '创建时间': 'Created Time',
    '支付时间': 'Payment Time',
    '确认时间': 'Confirmation Time',
    '完成时间': 'Completed Time',
    '转账信息': 'Transfer Information',
    '充值地址': 'Recharge Address',
    '复制': 'Copy',
    '交易哈希': 'Transaction Hash',
    '确认进度': 'Confirmation Progress',
    '确认': 'Confirmation',
    '查看区块浏览器': 'View Block Explorer',
    '取消订单': 'Cancel Order',
    '交易信息': 'Transaction Info',
    '区块确认数': 'Block Confirmations',
    '手续费': 'Fee',
    '备注': 'Remarks',
    '金额': 'Amount',
    '待支付': 'Pending Payment',
    '确认中': 'Confirming',
    '充值成功': 'Recharge Successful',
    '充值失败': 'Recharge Failed',
    '已取消': 'Cancelled',
    '请按照提示完成转账': 'Please complete the transfer as instructed',
    '交易正在区块链网络确认中': 'Transaction is being confirmed on-chain',
    '充值已成功到账': 'Recharge has been credited successfully',
    '充值失败请联系客服': 'Recharge failed, please contact support',
    '订单已取消': 'Order has been cancelled',
    '已复制到剪贴板': 'Copied to clipboard',
    '确定要取消这个充值订单吗': 'Are you sure you want to cancel this recharge order?',
    '取消订单功能开发中': 'Cancel order feature is under development'
  },

  // ==================== Withdrawal Page - Withdrawal.vue ====================
  withdrawal: {
    // Page title and navigation
    '提现': 'Withdrawal',
    '返回': 'Back',
    '提现记录': 'Withdrawal History',

    // Balance display
    '我的提现账户余额': 'My Withdrawal Account Balance',
    '可提现余额': 'Available Balance',
    '当前可提取余额': 'Current Available Balance',
    '信用分': 'Credit',

    // Form fields
    '提现金额': 'Withdrawal Amount',
    '请输入提现金额': 'Please enter withdrawal amount',
    '请输入自定义提款金额': 'Please enter custom withdrawal amount',
    '最大限度': 'Max',
    '提现地址': 'Withdrawal Address',
    '请输入提现地址': 'Please enter withdrawal address',
    '提现密码': 'Withdrawal Password',
    '请输入提现密码': 'Please enter withdrawal password',
    '资金密码': 'Fund Password',
    '请输入资金密码': 'Please enter fund password',
    '显示密码': 'Show Password',
    '隐藏密码': 'Hide Password',

    // Withdrawal rules
    '提款规则': 'Withdrawal Rules',
    '提现规则': 'Withdrawal Rules',
    '单笔范围': 'Single Range',
    '提现手续费': 'Withdrawal Fee',
    '提现金额范围': 'Withdrawal Amount Range',
    '资金将在1-24小时内到账': 'Funds will arrive within 1-24 hours',
    '手续费率': 'Fee Rate',
    '最小提现金额': 'Minimum Withdrawal',
    '最大提现金额': 'Maximum Withdrawal',
    '预计到账时间': 'Expected Arrival Time',
    '工作日内处理': 'Processed within business days',

    // Buttons and actions
    '确认提款': 'Confirm Withdrawal',
    '处理中': 'Processing',
    '提交申请': 'Submit Application',
    '设置资金密码': 'Set Fund Password',
    '忘记密码？': 'Forgot Password?',
    '取消': 'Cancel',
    '去设置': 'Go to Set',

    // Modal prompts
    '需要设置资金密码': 'Need to Set Fund Password',
    '为了您的资金安全，请先设置资金密码': 'For your fund security, please set fund password first',

    // Success messages
    '申请提交成功': 'Application Submitted Successfully',
    '您的提现申请已提交，请等待审核': 'Your withdrawal application has been submitted, please wait for review',
    '提现申请已提交': 'Withdrawal application submitted',
    '请等待审核': 'Please wait for review',

    // Error messages
    '申请提交失败': 'Application Submission Failed',
    '提现申请失败': 'Withdrawal application failed',
    '请稍后重试': 'Please try again later',
    '余额不足': 'Insufficient balance',
    '金额格式错误': 'Invalid amount format',
    '地址格式错误': 'Invalid address format',
    '资金密码错误': 'Incorrect fund password',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'You have a pending withdrawal request, please wait for it to be processed before submitting a new one',
    '信用分不足': 'Insufficient Credit Score',
    '信用分不足无法提款': 'Insufficient credit score, unable to withdraw',
    '需要KYC认证': 'KYC Required',
    '请先完成KYC认证后才能提现': 'Please complete KYC before withdrawing',
    'KYC等级': 'KYC Level',
    '今日剩余额度': 'Daily Remaining',
    '您有待还款订单，请还款后申请提现': 'You have outstanding loan orders. Please repay before requesting a withdrawal!',

    // System messages and logs
    '用户提现申请': 'User withdrawal application',
    '加载用户数据失败': 'Failed to load user data',
    '检查资金密码状态失败': 'Failed to check fund password status'
  },



  // ==================== Lucky Wheel Page - LuckyWheel.vue ====================
  luckyWheel: {
    // Page title
    '幸运轮': 'Lucky Wheel',
    '页面副标题': 'Grid draw · chase the highlight',

    // Draw info
    '剩余': 'Remaining',
    '次': 'times',
    '奖金': 'Prize',
    '抽奖': 'Draw',
    '奖品': 'Prize',
    '暂无中奖记录': 'No winning records',
    '总抽奖次数': 'Total Draws',
    '抽奖次数不足': 'Insufficient draws',
    '提示': 'Notice',
    '抽奖失败': 'Draw failed',
    '网络错误': 'Network error',
    '网络错误，请重试': 'Network error, please try again',

    // History records
    '中奖时间': 'Win Time',
    '中奖金额': 'Win Amount',
    '状态': 'Status',
    '暂无数据': 'No data',

    // Status text
    '待发放': 'Pending',
    '已发放': 'Distributed',
    '发放失败': 'Failed',

    // Win modal
    '恭喜中奖': 'Congratulations!',
    '确定': 'OK'
  },

  // ==================== Apply Funds Page - ApplyFunds.vue ====================
  applyFunds: {
    // Page title
    '申请备用金': 'Apply for Funds',

    // Step 1
    '经平台审核，您可向平台申请一笔借款': 'After platform review, you can apply for a loan',
    '借贷产品': 'Lending Product',
    '请选择产品': 'Please select product',
    '借款金额': 'Loan Amount',
    '输入借款金额': 'Enter loan amount',
    '还款周期': 'Repayment Period',
    '请输入还款周期': 'Enter repayment period',
    '天': 'days',
    '日利率': 'Daily Rate',
    '利息': 'Interest',
    '还款方式': 'Repayment Method',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Free service provided by HamiltonLane, please repay with external funds',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Free service provided by HamiltonLane, please repay with external funds',
    '放款机构': 'Lending Institution',
    '借款规则': 'Loan Rules',
    '下一步': 'Next',

    // Step 2
    '姓名': 'Name',
    '手机号': 'Phone',
    '证件上传': 'Document Upload',
    '身份证正面': 'ID Card Front',
    '身份证反面': 'ID Card Back',
    '点击上传': 'Click to Upload',
    '重新上传': 'Re-upload',
    '上传成功': 'Upload Successful',
    '上传失败': 'Upload Failed',
    '请上传身份证正面': 'Please upload ID card front',
    '请上传身份证反面': 'Please upload ID card back',
    '请输入': 'Please enter',
    '提交中': 'Submitting...',
    '确定': 'Confirm',
    '请选择图片文件': 'Please select an image file',
    '文件大小不能超过10MB': 'File size must not exceed 10MB',

    // Step 3
    '恭喜您申请成功': 'Congratulations on successful application',
    '您的借款已申请成功，待平台审核成功放款': 'Your loan application is successful, waiting for platform approval',

    // Product selector modal
    '选择借贷产品': 'Select Lending Product',

    // Error messages
    '申请失败': 'Application Failed',
    '申请失败，请重试': 'Application failed, please try again',

    // Product name translations
    '产品名称': {
      '快速借贷': 'Quick Loan',
      '标准借贷': 'Standard Loan',
      '长期借贷': 'Long-term Loan',
      '小额借贷': 'Micro Loan',
      '大额借贷': 'Large Loan',
      '短期借贷产品': 'Short-term Loan Product'
    },

    // Product description translations
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Suitable for short-term capital turnover, preferential interest rates, fast approval'
    },

    // API message translations
    'API消息': {
      '获取借贷产品成功': 'Successfully retrieved lending products'
    }
  },

  // ==================== Loan Records Page - LoanRecords.vue ====================
  loanRecords: {
    // Page title
    '借款记录': 'Loan Records',
    '借贷中心': 'Loan Center',
    '总记录': 'Total Records',
    '总借款': 'Total Loan',
    '进行中': 'In Progress',

    // Filter tabs
    '全部': 'All',

    // Loading and empty states
    '加载中': 'Loading',
    '没有更多数据了': 'No more data',

    // Record info
    '借款': 'Loan',
    '借款金额': 'Loan Amount',
    '还款周期': 'Repayment Period',
    '天': 'days',
    '日利率': 'Daily Rate',
    '利息': 'Interest',
    '还款方式': 'Repayment Method',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Free service provided by HamiltonLane, please repay with external funds',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Free service provided by HamiltonLane, please repay with external funds',
    '放款机构': 'Lending Institution',

    // Status
    '待审核': 'Pending',
    '已通过': 'Approved',
    '审核成功': 'Approved',
    '已驳回': 'Rejected',
    '审核失败': 'Rejected',
    '已还款': 'Repaid',
    '逾期': 'Overdue',
    '未知状态': 'Unknown Status'
  },

  // ==================== Robot Investment Page - RobotInvestment.vue ====================
  robotInvestment: {
    // Page title
    '详情': 'Details',
    '返回': 'Back',

    // Purchase information
    '申购金额': 'Purchase Amount',
    '购买金额': 'Purchase Amount',
    '最大': 'Max',
    '最小限额': 'Minimum Limit',
    '最大限额': 'Maximum Limit',
    '日收益率': 'Daily Return Rate',
    '周期': 'Period',
    '天': 'Days',

    // Balance information
    '可用余额': 'Available Balance',
    '可购次数': 'Purchase Times',

    // Buttons and status
    '处理中': 'Processing',
    '申购': 'Purchase',
    '余额错误': 'Balance Error',
    '无法获取有效的余额信息': 'Unable to fetch a valid balance',
    '输入错误': 'Input Error',
    '请输入申购金额': 'Please enter purchase amount',
    '请输入有效的申购金额': 'Please enter a valid purchase amount',
    '钱包未连接': 'Wallet Not Connected',
    '请先连接钱包': 'Please connect wallet first',
    '钱包信息错误': 'Wallet Info Error',
    '请重新连接钱包': 'Please reconnect wallet',
    '钱包地址无效': 'Invalid Wallet Address',
    '授权已失效': 'Authorization Expired',
    '请重新授权USDC后再进行投资': 'Please re-authorize USDC before investing',
    '授权检查失败': 'Authorization Check Failed',
    '请稍后重试或重新连接钱包': 'Please retry later or reconnect wallet',
    '金额不足': 'Amount Too Low',
    '申购金额不能少于': 'Purchase amount cannot be less than',
    '金额超限': 'Amount Too High',
    '申购金额不能超过': 'Purchase amount cannot exceed',
    '余额不足': 'Insufficient Balance',
    '您的可用余额为': 'Your available balance is',
    '无法完成此次申购': 'unable to complete this purchase',
    '申购成功': 'Purchase Successful',
    '订单号': 'Order Number',
    '申购失败': 'Purchase Failed',
    '申购失败，请稍后重试': 'Purchase failed, please try again later',
    '网络错误，请稍后重试': 'Network error, please try again later'
  },

  // ==================== KYC - Kyc.vue ====================
  kyc: {
    '身份认证': 'Identity Verification',
    '加载中': 'Loading...',
    '未认证': 'Unverified',
    '已通过Lv1': 'Lv1 Verified',
    '已通过Lv2': 'Lv2 Verified',
    '完成认证后才可提现': 'Complete verification to enable withdrawals',
    '可继续升级Lv2提高额度': 'Upgrade to Lv2 for higher limits',
    '可享受最高提现额度': 'Highest withdrawal limits unlocked',
    '单笔限额': 'Single Limit',
    '今日剩余': 'Daily Remaining',
    '审核中': 'Under Review',
    '请耐心等待审核结果': 'Please wait for review',
    '已驳回': 'Rejected',
    '请修改后重新提交': 'Please update and resubmit',
    'Lv1基础认证': 'Lv1 Basic Verification',
    'Lv2高级认证': 'Lv2 Advanced Verification',
    '真实姓名': 'Full Name',
    '请输入真实姓名': 'Enter your full name',
    '邮箱': 'Email',
    '请输入邮箱': 'Enter your email',
    '证件号码': 'ID Number',
    '请输入证件号码': 'Enter your ID number',
    '国家地区': 'Country / Region',
    '请输入国家或地区': 'Enter country or region',
    '证件正面': 'ID Front',
    '证件反面': 'ID Back',
    '提交Lv1认证': 'Submit Lv1',
    '提交Lv2认证': 'Submit Lv2',
    '提交中': 'Submitting...',
    '请录制本人与证件同框视频': 'Record a video of yourself holding your ID',
    '上传同框视频': 'Upload ID video',
    '您已完成全部认证': 'All verifications completed',
    '上传失败': 'Upload failed',
    '提交成功': 'Submitted',
    '提交失败': 'Submit failed',
    '已完成': 'Completed',
    '基础认证': 'Basic',
    '高级认证': 'Advanced'
  },

  // ==================== Set Fund Password Page - SetFundPassword.vue ====================
  setFundPassword: {
    // Page title
    '设置资金密码': 'Set Fund Password',
    '安全中心': 'Security Center',

    // Password hints
    '密码长度至少6位': 'Password must be at least 6 characters',
    '密码长度不超过20位': 'Password must not exceed 20 characters',

    // Confirm password
    '确认密码': 'Confirm Password',
    '两次输入的密码一致': 'Passwords match',

    // Buttons
    '设置中': 'Setting...',
    '确定': 'Confirm',

    // API response messages
    '参数验证失败': 'Parameter validation failed',
    '您已设置过资金密码，如需修改请联系客服': 'You have already set a fund password. Please contact customer service to modify it',
    '资金密码设置成功': 'Fund password set successfully',
    '设置失败': 'Setting failed',
    '获取状态失败': 'Failed to get status',

    // Frontend prompt messages
    '设置成功': 'Set successfully',
    '请稍后重试': 'Please try again later',
    '设置资金密码失败': 'Failed to set fund password'
  },

  // ==================== Modify Fund Password Page - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Page title
    '修改资金密码': 'Modify Fund Password',
    '修改安全密码': 'Modify Security Password',
    '返回': 'Back',

    // Status display
    '已设置资金密码': 'Fund password has been set',

    // Form fields
    '原密码': 'Current Password',
    '请输入原密码': 'Please enter current password',
    '新密码': 'New Password',
    '请输入新密码': 'Please enter new password',
    '确认新密码': 'Confirm New Password',
    '请再次输入新密码': 'Please enter new password again',

    // Buttons and actions
    '确认修改': 'Confirm Modification',
    '修改中': 'Modifying...',
    '忘记原密码': 'Forgot current password?',
    '忘记安全密码': 'Forgot security password?',
    '联系客服': 'Contact Support',
    '取消': 'Cancel',

    // Tips
    '原密码不能为空': 'Current password cannot be empty',
    '原密码错误': 'Current password is incorrect',
    '新密码不能与原密码相同': 'New password cannot be same as current password',
    '密码修改成功': 'Password modified successfully',
    '密码修改失败': 'Password modification failed',
    '如需重置安全密码，请联系客服人员协助处理': 'To reset your security password, please contact customer service for assistance',

    // API response messages
    '参数验证失败': 'Parameter validation failed',
    '您尚未设置资金密码': 'You have not set a fund password yet',
    '资金密码修改成功': 'Fund password modified successfully',
    '修改失败': 'Modification failed',

    // Frontend prompt messages
    '修改安全密码失败': 'Failed to modify security password',
    '请稍后重试': 'Please try again later',

    // Password validation hints
    '密码长度6-20位': 'Password length 6-20 characters',
    '两次输入的密码一致': 'Passwords match'
  },

  // ==================== Airdrop Rewards Page - AirdropRewards.vue ====================
  airdropRewards: {
    // Page title
    '空投奖励': 'Airdrop Rewards',
    '返回': 'Back',

    // Statistics
    '累计获得 (USDC)': 'Total Received (USDC)',
    '待发放数量': 'Pending Count',
    '待发放金额 (USDC)': 'Pending Amount (USDC)',

    // Filter tabs
    '全部': 'All',
    '待发放': 'Pending',
    '已发放': 'Distributed',

    // Status text
    '已取消': 'Cancelled',
    '发放失败': 'Distribution Failed',
    '失败': 'Failed',
    '未知': 'Unknown',

    // Time related
    '发放时间': 'Distribution Time',

    // Loading states
    '加载中': 'Loading...',
    '加载更多': 'Loading more...',
    '没有更多数据了': 'No more data',
    '暂无空投奖励记录': 'No airdrop reward records',

    // Reward information
    '总奖励': 'Total Rewards',
    '今日奖励': 'Today\'s Rewards',
    '待领取': 'Pending',
    '已领取': 'Claimed',

    // Reward list
    '奖励记录': 'Reward Records',
    '奖励类型': 'Reward Type',
    '奖励金额': 'Reward Amount',
    '获得时间': 'Received Time',
    '领取状态': 'Claim Status',
    '领取': 'Claim',

    // Reward types
    '注册奖励': 'Registration Reward',
    '邀请奖励': 'Referral Reward',
    '活动奖励': 'Event Reward',
    '签到奖励': 'Check-in Reward',
    '推广奖励': 'Promotion Reward',

    // Action tips
    '领取成功': 'Claimed successfully',
    '领取失败': 'Claim failed',
    '暂无奖励记录': 'No reward records',
    '全部领取': 'Claim All'
  },

  // ==================== Invite Modal - InviteModal.vue ====================
  invite: {
    // Modal title and content
    '邀请好友一起赚币': 'Invite Friends to Earn Together',
    '复制邀请码': 'Copy Invite Code',
    '朋友扫二维码注册加入': 'Friends scan QR code to register',
    '邀请链接': 'Invite Link',

    // Error messages
    '加载邀请数据失败': 'Failed to load invite data',
    '加载失败': 'Loading failed',
    '获取邀请信息失败，请稍后重试': 'Failed to get invite info, please try again later',
    '生成二维码失败': 'Failed to generate QR code',

    // Copy functionality
    '邀请码已复制': 'Invite code copied',
    '邀请链接已复制': 'Invite link copied',
    '复制失败': 'Copy failed',
    '请手动复制': 'Please copy manually'
  },

  // ==================== Top Header - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Select Network',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Logging in...',
    '连接钱包': 'Connect Wallet',
    '连接中': 'Connecting...',
    '已连接': 'Connected',
    '连接成功': 'Connection Successful!',
    '钱包已成功连接': 'Wallet connected successfully',
    '钱包信息': 'Wallet Info',
    '钱包地址': 'Wallet Address',
    '断开连接': 'Disconnect',
    '已断开连接': 'Disconnected',
    '正在初始化': 'Initializing...',
    '正在切换网络': 'Switching network...',
    '登录完成': 'Login completed',
    '请在钱包中确认': 'Please confirm in wallet...',
    '登录成功': 'Login successful',

    // Wallet connection error messages
    '钱包连接失败': 'Wallet connection failed',
    '未知错误': 'Unknown error',
    '认证失败，请重试连接钱包': 'Authentication failed, please retry wallet connection',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Wallet connection request is being processed, please wait or refresh the page and try again',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Wallet connection request is pending, please confirm in your wallet',
    '授权失败': 'Authorization failed',
    '交易被撤销，可能是合约错误或余额不足': 'Transaction reverted, possibly due to contract error or insufficient balance',

    // Wallet connection status messages
    '欢迎！您的账户已创建成功': 'Welcome! Your account has been created successfully',
    '钱包连接成功': 'Wallet connected successfully',
    '钱包已断开连接': 'Wallet disconnected',
    '是否断开钱包连接？': 'Disconnect wallet connection?',

    '确定': 'OK',

    // New translation keys - Chinese text in TopHeader.vue
    '钱包未连接，请先连接钱包': 'Wallet not connected, please connect wallet first',
    '中文（简体）': 'Chinese (Simplified)',
    '用户取消了授权': 'User cancelled authorization',
    'ETH余额不足，无法支付Gas费用': 'Insufficient ETH balance, cannot pay gas fees',
    'Gas费用设置过低': 'Gas fee set too low',
    '交易nonce错误，请重试': 'Transaction nonce error, please retry',
    'Gas价格过低，请提高Gas价格': 'Gas price too low, please increase gas price',
    '合约参数错误，请检查网络和合约地址': 'Contract parameter error, please check network and contract address',
    '余额不足，无法完成授权': 'Insufficient balance, cannot complete authorization',
    '请安装 MetaMask 或其他以太坊钱包': 'Please install MetaMask or other Ethereum wallet',
    '未检测到钱包': 'Wallet not detected',
    '请使用钱包内置浏览器打开本站，或先安装 MetaMask / TokenPocket 后再登录。': 'Open this site in your wallet browser, or install MetaMask / TokenPocket first.',
    '安装 MetaMask': 'Install MetaMask',
    '我知道了': 'Got it',
    '请安装 TronLink 钱包': 'Please install TronLink wallet',
    '未找到授权目标地址，请先获取系统配置': 'Authorization target address not found, please get system configuration first',
    '获取授权地址失败': 'Failed to get authorization address',
    '不支持的网络类型': 'Unsupported network type',
    '网络切换可能未完成，当前链ID': 'Network switch may not be complete, current chain ID',
    '请刷新页面重试': 'Please refresh page and retry',
    '网络连接失败': 'Network connection failed',
    '授权地址格式错误': 'Authorization address format error',
    '合约地址格式错误': 'Contract address format error',
    'ETH余额不足！当前余额': 'Insufficient ETH balance! Current balance',
    '需要': 'Required',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Wallet connection request is pending, please confirm in MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Wallet connection request is pending, please confirm in Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Wallet connection request is pending, please confirm in Coinbase Wallet'
  },

  // ==================== Wallet Info - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Wallet address copied to clipboard',
    '钱包信息已刷新': 'Wallet information refreshed',
    '钱包信息已刷新（自动重连成功）': 'Wallet information refreshed (auto-reconnection successful)',
    '登录已过期，请重新连接钱包': 'Login expired, please reconnect wallet',
    '刷新失败': 'Refresh failed',
    '交易历史功能开发中': 'Transaction history feature under development',
    '确定要断开钱包连接吗': 'Are you sure you want to disconnect the wallet',
    '钱包已断开连接': 'Wallet disconnected',
    '断开连接失败': 'Disconnection failed',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Are you sure you want to test the collection function? This will check if your wallet can perform collection operations',
    '归集测试完成': 'Collection test completed',
    '归集测试失败': 'Collection test failed',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Are you sure you want to collect ETH? This will transfer ETH from your wallet to the collection address',
    'ETH归集成功': 'ETH collection successful',
    'ETH归集失败': 'ETH collection failed'
  },

  // ==================== Flash Options - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': 'Flash Options',
    '请先连接钱包': 'Please Connect Wallet',
    '连接钱包后即可开始闪电期权交易': 'Connect your wallet to start flash options trading',
    '连接钱包': 'Connect Wallet',
    '加载中': 'Loading...',
    '暂无可交易资产': 'No tradable assets',
    '请稍后再试': 'Please try again later',
    '时间': 'Time',
    '金额': 'Amount',
    '回报额': 'Return',
    '利润': 'Profit',
    '当前持仓': 'Open Positions',
    '暂无持仓': 'No positions',
    '买涨': '▲ Up',
    '买跌': '▼ Down',
    '开仓': 'Entry',
    '入场价': 'Entry Price',
    '出场价': 'Exit Price',
    '收益率': 'Return',
    '投入': 'Amount',
    '入场时间': 'Entry Time',
    '出场时间': 'Exit Time',
    '交易时长': 'Duration',
    '实时价': 'Live Price',
    '倒计时': 'Countdown',
    '交易记录': 'Trade History',
    '暂无记录': 'No records',
    '生成海报': 'Generate Poster',
    '交易海报': 'Trade Poster',
    '保存图片': 'Save Image',
    '分享': 'Share',
    '生成海报失败': 'Failed to generate poster',
    '海报已保存': 'Poster saved',
    '闪期权交易海报': 'Flash Options',
    '仅供展示不构成投资建议': 'For display only. Not investment advice.',
    '智能交易': 'Smart Trade',
    '交易标的': 'Asset',
    '风险类型': 'Risk Type',
    '投入金额': 'Amount',
    '提交申请': 'Submit',
    '我的AI订单': 'My AI Orders',
    '稳健型': 'Conservative',
    '平衡型': 'Balanced',
    '进取型': 'Aggressive',
    '稳健': 'Safe',
    '平衡': 'Balanced',
    '进取': 'Aggro',
    '低风险低回报适合稳健投资者': 'Low risk, low return. Suitable for conservative investors.',
    '中等风险中等回报适合大多数投资者': 'Medium risk, medium return. Suitable for most investors.',
    '高风险高回报适合激进投资者': 'High risk, high return. Suitable for aggressive investors.',
    '待审核': 'Pending',
    '运行中': 'Running',
    '已停止': 'Stopped',
    '已结算': 'Settled',
    '已驳回': 'Rejected',
    'AI剩余': 'Remaining',
    'AI做单': 'Trades',
    'AI笔': '',
    'AI胜': 'W',
    'AI负': 'L',
    '请先选择交易标的': 'Please select an asset first',
    '请输入有效金额': 'Please enter a valid amount',
    'AI交易申请已提交': 'AI trade submitted, pending review',
    'AI提交失败': 'Submit failed',
    '取消申请': 'Cancel',
    '停止交易': 'Stop',
    '确认停止AI交易': 'Stop AI trading? Remaining funds will be refunded.',
    '停止失败': 'Stop failed',
    '确认取消AI申请': 'Cancel this AI trading application? Frozen funds will be refunded.',
    '取消失败': 'Cancel failed',
    '涨': 'Up',
    '跌': 'Down',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Settling...',
    '加载配置失败': 'Failed to load config',
    '请完善交易信息': 'Please complete trade info',
    '下单失败': 'Order failed',
    '买涨成功': 'Buy Up success',
    '买跌成功': 'Buy Down success',
    '等待行情数据': 'Waiting for market data...',
    '余额不足': 'Insufficient Balance',
    '资产不可用': 'Asset unavailable',
    '周期不可用': 'Period unavailable',
    '实盘交易': 'Live Trading',
    '模拟交易': 'Demo Trading',
    '模拟': 'Demo',
    '体验金': 'Demo',
    '当前为模拟交易模式不影响真实资产': 'Demo mode — does not affect real assets',
    '体验金不足': 'Insufficient demo balance',
    '可用余额': 'Avail.',
    '累计盈亏': 'PnL',
    '请安装钱包插件': 'Please install a wallet extension (e.g. MetaMask)',
    '连接失败': 'Connection failed',
  },

  // ==================== Bottom Navigation - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Home',
    '投资': 'Invest',
    '闪期权': 'Flash',
    '算力申请': 'Wealth',
    '农场': 'Farm',
    '资产': 'Profile'
  },

  farm: {
    '副标题': 'Check-in · Water · Boost',
    '我的农场': 'My Farm',
    '规则': 'Rules',
    '当前加息': 'Boost',
    '待用加息卡': 'Boost Cards',
    '日利率': 'daily rate',
    '体验卡': 'Cards',
    '今日浇水': 'Water Today',
    '浇水已用完': 'Used up today',
    '明日再来': 'Come back tomorrow',
    '浇水次数': '{left}/{total}',
    '每日签到': 'Daily Check-in',
    '签到说明': 'Check in daily for 3 waters. Unused waters reset each day.',
    '已签到': 'Checked In',
    '签到领水': 'Check In',
    '待领取种子': 'Seeds to Claim',
    '完成理财获得': 'Earned from wealth subscriptions',
    '领取': 'Claim',
    '成长中': 'Growing',
    '我的农田': 'My Fields',
    '去申购': 'Subscribe Wealth',
    '加载中': 'Loading...',
    '暂无种子': 'No seeds yet. Subscribe to a wealth product to earn one.',
    '次浇水': 'waters',
    '浇水': 'Water',
    '可兑换': 'Redeem card',
    '兑换': 'Redeem',
    '体验卡背包': 'Boost Card Bag',
    '暂无体验卡': 'No boost cards available',
    '生效中': 'Active',
    '待用': 'Ready',
    '购买理财可用': 'Use when subscribing',
    '即将过期': 'Expiring soon',
    '剩余小时': '{hours}h left',
    '规则标题': 'Farm Rules',
    '规则1': 'Claim a seed after each successful wealth subscription (1 seed per order).',
    '规则2': 'Daily check-in grants {count} waters. Unused waters reset at day end.',
    '规则3': 'Mature seeds redeem into boost cards stored in your bag permanently.',
    '规则4': 'When subscribing (except V0), select up to {cards} cards per order, max +{rate}% boost.',
    '规则5': 'Boost applies only to that order. Each card is single-use.',
    '规则6': 'You also get {count} friend-water chances daily. Add friends by UID and help water their growing seeds. No extra rewards.',
    '知道了': 'Got it',
    '签到成功': 'Check-in successful',
    '今日已签到': 'Already checked in today',
    '领取成功': 'Seed claimed',
    '浇水成功': 'Watered',
    '兑换成功': 'Boost card redeemed',
    '操作失败': 'Action failed',
    apiErrors: {
      '未登录': 'Please connect your wallet first',
      '登录已过期': 'Session expired, please reconnect your wallet',
      '无效身份': 'Invalid session, please reconnect your wallet',
      '认证失效，请重新连接钱包': 'Session expired, please reconnect your wallet',
      'V0理财产品不可使用加息卡': 'Boost cards cannot be used on V0 products',
      '加息卡无效或已使用': 'Boost card is invalid or already used',
      '种子不存在': 'Seed not found',
      '该种子不可领取': 'This seed cannot be claimed',
      '请先签到领取今日浇水次数': "Check in first to get today's waters",
      '今日浇水次数已用完': 'No waters left today',
      '该种子当前不可浇水': 'This seed cannot be watered now',
      '种子已成熟，请兑换加息卡': 'Seed is mature, redeem it for a boost card',
      '种子尚未成熟': 'Seed is not mature yet',
      '种子模板不存在': 'Seed template not found',
      '对方不是你的好友': 'This user is not your friend',
      '请输入有效的好友UID': 'Please enter a valid friend UID',
      '不能添加自己为好友': "You can't add yourself as a friend",
      '该UID用户不存在': 'No user found with this UID',
      '已经是好友了': 'Already friends',
      '好友浇水功能未开启': 'Friend watering is not enabled',
      '好友不存在': 'Friend not found',
      '今日帮浇次数为0': 'Friend watering is unavailable today',
      '请在自己的农场浇自己的种子': 'Water your own seeds on My Farm',
      '种子已成熟': 'Seed is already mature',
      '今日帮浇次数已用完': 'No friend waters left today',
      '帮浇繁忙，请重试': 'Busy, please try again'
    },
    '好友农场': 'Friend Farm',
    '今日帮浇': 'Friend Waters Left',
    '好友数': 'Friends',
    '添加好友': 'Add Friend',
    '输入好友UID': 'Enter friend UID',
    '添加': 'Add',
    '暂无好友': 'No friends yet. Add one by UID.',
    '请选择好友': 'Select a friend to view their farm',
    '好友暂无成长中种子': 'This friend has no growing seeds',
    '好友农田': 'Friend Field',
    '某好友农田': "{name}'s Field",
    '帮浇': 'Help Water',
    '帮浇已用完': 'Friend waters used up',
    '明日再来帮浇': 'Come back tomorrow',
    '添加好友成功': 'Friend added',
    '帮浇成功': 'Helped water'
  },

  // ==================== Balance Logs Page - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Balance Logs',
    '总收入': 'Total Income',
    '总支出': 'Total Expenses',
    '净收益': 'Net Profit',
    '记录总数': 'Total Records',
    '全部': 'All',
    '用户充值': 'User Recharge',
    '管理操作': 'System Operation',
    '用户提现': 'User Withdrawal',
    '借贷': 'Loan',
    '借贷到账': 'Loan Credited',
    '理财产品': 'Wealth Products',
    '算力申请': 'Computing Application',
    '机器人收益': 'Robot Earnings',
    '算力收益': 'Computing Earnings',
    '空投': 'Airdrop',
    '幸运轮': 'Lucky Wheel',
    '闪期权': 'Flash Options',
    '闪兑': 'Flash Swap',
    '合约': 'Futures',
    '加载中': 'Loading',
    '暂无记录': 'No Records',
    '暂无账变记录': 'No balance change records',
    '余额变化': 'Balance Change',
    '本金': 'Principal',
    '手续费': 'Fee',
    '申请金额': 'Request Amount',
    '实际到账': 'Net Amount',
    '加载更多': 'Load More',
    '记录详情': 'Record Details',
    '业务类型': 'Business Type',
    '操作类型': 'Operation Type',
    '变动金额': 'Amount Changed',
    '变动前余额': 'Balance Before',
    '变动后余额': 'Balance After',
    '变动原因': 'Reason',
    '备注': 'Remark',
    '状态': 'Status',
    '交易哈希': 'Transaction Hash',
    '创建时间': 'Created Time',
    '处理时间': 'Processed Time',
    '刚刚': 'Just now',
    '分钟前': ' minutes ago',
    '小时前': ' hours ago',

    // Business Types (some keys exist elsewhere, commented to avoid duplicates)
    // '充值': 'Recharge',
    // '提现': 'Withdrawal',
    // '算力申请': 'Computing Power', // Duplicate key, already defined elsewhere
    'AI机器人': 'AI Robot',
    '解押': 'Redeem',
    '管理员操作': 'System Operation',
    '推荐佣金': 'Referral Commission',
    // '奖励': 'Reward',
    '幸运轮盘': 'Lucky Wheel',
    '其他': 'Other',

    // Operation types (opType keys from API)
    op_recharge_success: 'User Recharge',
    op_withdraw_apply: 'Withdrawal Request',
    op_withdraw_complete: 'Withdrawal Completed',
    op_withdraw_reject: 'Withdrawal Rejected',
    op_wealth_subscribe: 'Wealth Subscription',
    op_wealth_earning: 'Wealth Earnings',
    op_wealth_redeem: 'Wealth Redemption',
    op_stake: 'Computing Application',
    op_stake_approve: 'Computing Application',
    op_computing_earning: 'Computing Earnings',
    op_unstake_return: 'Unstaking Return',
    op_loan_credit: 'Loan Credited',
    op_ai_earning: 'Robot Earnings',
    op_admin_adjust: 'System Adjustment',
    op_asset_debit: 'System Debit',
    op_airdrop_issue: 'Airdrop Distribution',
    op_airdrop: 'Lucky Wheel',
    op_flash_option_buy: 'Flash Option Order',
    op_flash_option_win: 'Flash Option Profit',
    op_flash_option_draw: 'Flash Option Draw',
    op_flash_option_lose: 'Flash Option Loss',
    op_demo_flash_option_buy: 'Demo Flash Option Order',
    op_demo_flash_option_win: 'Demo Flash Option Profit',
    op_demo_flash_option_draw: 'Demo Flash Option Draw',
    op_demo_flash_option_lose: 'Demo Flash Option Loss',
    op_demo_flash_option_reset: 'Demo Balance Reset',
    op_swap_out: 'Swap Out',
    op_swap_in: 'Swap In',
    op_futures_open: 'Futures Open',
    op_futures_close: 'Futures Close',
    op_token_sale_subscribe: 'Token Subscription',

    action_add: 'Add',
    action_subtract: 'Subtract',
    action_set: 'Adjust',

    status_pending: 'Pending Review',
    status_success: 'Success',
    status_failed: 'Failed',

    // Status (legacy Chinese keys)
    '待审核': 'Pending Review',
    '处理中': 'Processing',
    '待处理': 'Pending',
    '已完成': 'Completed',
    '失败': 'Failed',
    '已失败': 'Failed',
    '成功': 'Success',
    '已取消': 'Cancelled',

    // Action Types
    '增加': 'Add',
    '减少': 'Subtract',
    '设置': 'Set',
    '调整': 'Adjust',

    // Account Types
    '余额变动': 'Balance Change',
    '质押变动': 'Stake Change',

    // Reason Translations
    'reason_recharge_arrived': 'Recharge Arrived',
    'reason_withdrawal_apply': 'Withdrawal Application, Balance Frozen',
    'reason_withdrawal_rejected': 'Withdrawal Application Rejected, Frozen Balance Returned',
    'reason_withdrawal_success': 'Withdrawal Successful',
    'reason_computing_apply': 'Computing Power Application, Balance Frozen',
    'reason_unstake_success': 'Unstaking Successful, Stake Unfrozen to Balance',
    'reason_computing_earning': 'Computing Power Earnings Arrived',
    'reason_computing_unstake': 'Computing Power Expired Unstaking',
    'reason_robot_invest': 'AI Robot Investment',
    'reason_robot_earning': 'Robot Earnings Arrived',
    'reason_loan_credit': 'Loan Approval Credited',
    'reason_unstake_approved': 'Unstaking Application Approved',
    'reason_referral_commission': 'Referral Commission Arrived',
    'reason_lucky_wheel_reward': 'Lucky Wheel Prize Reward',
    'reason_airdrop': 'Airdrop Reward',
    'reason_reward': 'Reward Distribution',
    'reason_airdrop_issue': 'Airdrop Distribution',
    'reason_flash_option_buy': 'Flash Option Order',
    'reason_flash_option_win': 'Flash Option Profit',
    'reason_flash_option_draw': 'Flash Option Draw Refund',
    'reason_flash_option_lose': 'Flash Option Loss',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Remark Translations
    'remark_recharge_order': 'Recharge Order',
    'remark_withdrawal_order': 'Withdrawal Order',
    'remark_application_rejected': 'Application Rejected',
    'remark_transaction_hash': 'Transaction Hash',
    'remark_computing_application': 'Computing Application',
    'remark_unstake_application': 'Unstaking Application',
    'remark_robot_order': 'Robot Order',
    'remark_lucky_wheel_reward': 'Lucky Wheel Reward',
    'remark_robot_earning': 'Robot Earnings',
    'remark_computing_earning': 'Computing Earnings',
    'remark_computing_earning_to_stake': 'Computing Earnings Added to Stake',
    'remark_flash_option_buy': 'Flash Option Order',
    'remark_flash_option_win': 'Flash Option Profit',
    'remark_flash_option_draw': 'Flash Option Draw Refund',
    'remark_flash_option_lose': 'Flash Option Loss',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Airdrop Distribution',

    // Wealth business types (backend business_type_text)
    '理财申购': 'Wealth Subscription',
    '理财收益': 'Wealth Earnings',
    '理财赎回': 'Wealth Redemption',
    '提现申请': 'Withdrawal Request',
    '提现完成': 'Withdrawal Completed',
    '模拟体验金重置': 'Demo Balance Reset',
    '闪兑兑出': 'Swap Out',
    '闪兑兑入': 'Swap In',
    '合约开仓': 'Futures Open',
    '合约平仓': 'Futures Close',
    '代币认购': 'Token Subscription',

    'reason_wealth_subscribe': 'Wealth Subscription',
    'reason_wealth_earning': 'Wealth Earnings',
    'reason_wealth_redeem': 'Wealth Redemption',

    '闪期权下单': 'Flash Option Order',
    '闪期权盈利': 'Flash Option Profit',
    '闪期权平局': 'Flash Option Draw',
    '闪期权亏损': 'Flash Option Loss',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Airdrop Distribution',
    '算力收益发放': 'Computing Earnings Distribution',
    '奖励发放': 'Reward Distribution',
    '资产中心': 'Asset Center',
    '筛选': 'Filter',
    '更多类型': 'More Types',
    '金额方向': 'Amount Direction',
    '流入': 'Inflow',
    '流出': 'Outflow',
    '关键词': 'Keyword',
    '搜索类型原因备注': 'Search type/reason/remark',
    '重置': 'Reset',
    '完成': 'Done',
    '当前筛选': 'Current Filter',
    '记录条数': 'Records',
    '净额': 'Net',
    '点击查看详情': 'Tap to view details',
    '账变记录页面已加载': 'Balance logs page loaded'
  },

  // Home Page
  home: {
    // Main Content
    'titleLine1': 'Plenty',
    'titleLine2': 'Reimagining Agriculture',
    'mainTitle': 'Plenty: Indoor Vertical Farming',
    'mainDescription': 'We grow fresh, flavorful produce in controlled indoor environments—better for the world and for you.',
    'heroIntro': 'Indoor vertical farming for a cleaner food system',
    'brandName': 'Plenty',
    'heroHeadline': 'Reimagining Agriculture',
    'heroLead': 'Our planet is facing a changing climate and running out of farmable land just when we need it most. Plenty grows fresh produce vertically indoors so farming can be better for the world and for you.',
    'heroMarketTag': 'Green Tech Energy',
    'ctaWealth': 'View wealth products',
    'startJoining': 'Connect Wallet',
    'tradingBotsLink': 'Visit website',
    'statYieldTitle': 'Yield per acre',
    'statYieldDesc': 'The Virginia farm is designed to produce up to 86x more strawberries per acre.',
    'statLandTitle': 'Land use',
    'statLandDesc': 'Growing up uses as little as 1% of the land required by conventional farms.',
    'statWaterValue': 'Water',
    'statWaterTitle': 'Water savings',
    'statWaterDesc': 'The Virginia farm has the potential to save millions of gallons of water each year.',
    'futureKicker': 'Building a Cleaner Future',
    'futureTitle': 'A cleaner food future',
    'pillar1Title': 'Less land & less water',
    'pillar1Desc': 'Farms grow up, producing more food on less land with closed-loop water systems.',
    'pillar2Title': 'Grown closer to you',
    'pillar2Desc': 'Plenty farms can be built in cities or deserts so more people can eat locally.',
    'pillar3Title': 'Less pollution & runoff',
    'pillar3Desc': 'Indoor farms can monitor and control what comes in and out, unlike open fields.',
    'whoKicker': 'Who We Are',
    'whoTitle': 'Who we are',
    'whoCopy': 'We are scientists, farmers, business people, creatives, and a few friendly robots. What started at the University of Wyoming now continues in Virginia.',
    'founderQuote': 'I felt that technology could help feed a lot of people, extend lives, fight environmental destabilization, and give land back to the natural landscape.',
    'founderName': 'Nate Storey · Co-Founder, Plenty',
    'farmsKicker': 'Where We Farm',
    'farmsTitle': 'Where we farm',
    'farm1Place': 'Laramie, Wyoming',
    'farm1Title': 'The original Plenty farm',
    'farm1Desc': 'R&D center where crops are tested for hydration, nutrients, and light before scaling.',
    'farm2Place': 'Richmond, Virginia',
    'farm2Title': 'The berry farm',
    'farm2Desc': 'The world’s first indoor vertical berry farm at scale, designed for over 4 million pounds of strawberries a year.',
    'farm3Place': 'Coming soon',
    'farm3Title': 'The next Plenty farm',
    'farm3Desc': 'We are expanding this technology to new crops and communities. The next farm could be near you.',
    'modulesKicker': 'Technical Modules',
    'modulesTitle': 'Technical modules',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',

    // Investment Section
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Category Content
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Common
    'more': 'More',
    'collapse': 'Collapse',

    // Earnings Section
    'earningsTitle': 'Performance',
    'earningsSubtitle': 'Selected account returns',
    'walletAddressLabel': 'Wallet Address',
    'profitLabel': 'Profit',

    // Home hero and metrics
    'walletConnected': 'Wallet Connected',
    'walletNotConnected': 'Wallet Not Connected',
    'metricPnl': '24h PnL',
    'metricWinRate': 'Win Rate',
    'metricActiveBots': 'Active Bots',

    // Company Introduction
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane is a global high-tech enterprise headquartered in Singapore, jointly initiated and established by Bitmain, A*STAR Institute of High Performance Computing (IHPC), and Core Scientific, Inc...',
    'companyFull': 'HamiltonLane is a global high-tech enterprise headquartered in Singapore, jointly initiated and established by Bitmain, A*STAR Institute of High Performance Computing (IHPC), and Core Scientific, Inc. The company focuses on the deep integration of artificial intelligence (AI) and blockchain technology, committed to building the world\'s leading cryptocurrency computing power systems and intelligent computing power ecosystem infrastructure, driving the sustainable development of the new generation of intelligent economy. As an innovative enterprise jointly founded by three institutions with global influence in their respective fields, HamiltonLane brings together Bitmain\'s core technological advantages in blockchain chip design and computing power hardware, IHPC\'s international research strength in high-performance computing and AI algorithm optimization, and Core Scientific\'s leading experience in blockchain infrastructure construction and data center operations. The synergistic cooperation of the three parties enables HamiltonLane to have strong technological integration capabilities and global resource allocation capabilities, laying a solid foundation for the efficient, secure, and intelligent development of computing power networks. HamiltonLane\'s independently developed Decentralized Intelligent Computing Network (DICN) integrates AI computing power scheduling, blockchain smart contracts, and high-performance computing technology to achieve automated management and revenue optimization of computing power resources. The system can achieve cross-network computing power allocation, real-time monitoring, and energy efficiency optimization in multi-chain ecosystems, significantly improving computing power utilization and overall revenue efficiency. At the same time, through deep learning and predictive models of AI algorithms, the system can achieve automatic risk identification, market trend analysis, and dynamic resource scheduling, providing global users with transparent, secure, and intelligent computing power service experiences. HamiltonLane\'s business system covers AI computing power network construction, blockchain computing power management, cloud high-performance computing, data encryption and privacy protection, and on-chain revenue investment systems. The company actively promotes the application of artificial intelligence computing power in decentralized finance (DeFi), Web3.0, cloud computing, and scientific research computing industries, building a full-chain computing power solution from underlying hardware to upper-layer ecosystems. Adhering to the development philosophy of "Intelligence Empowers the Future," HamiltonLane takes technological innovation as the core driving force and compliance, security, and transparency as operational principles, committed to providing global institutions and individual investors with integrated computing power asset management and AI-driven investment solutions. Through the joint technology and industrial collaboration of Bitmain, IHPC, and Core Scientific, HamiltonLane is accelerating the construction of a global intelligent computing power infrastructure network, becoming an important bridge connecting artificial intelligence and blockchain economy, providing solid computing power support and strategic driving force for global digitalization and intelligentization processes.',
    'persistentLink': 'Learn More About Persistent Systems',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Frequently Asked Questions',
    'faq1Question': 'How does Plenty grow strawberries?',
    'faq1Answer': 'Plenty uses vertical grow towers with lighting, water, and nutrient systems. Indoor growing delivers the right light, water, and nutrients while using less land and water.',
    'faq2Question': 'Does Plenty have organic or other certifications?',
    'faq2Answer': 'Plenty is not certified organic. Indoor technology lets us control growing in ways outdoor farms cannot. Strawberries are non-GMO, and farms are SQF- and GMP-certified.',
    'faq3Question': 'Do you grow anything besides strawberries?',
    'faq3Answer': 'We currently grow strawberries for market. Farms have grown leafy greens in the past, and plant scientists continue exploring new crops.',

    // Partner Platforms
    'partnerTitle': 'Partners',

    // Customer Service
    'customerServiceDevelopment': 'Customer service is under development, please stay tuned!'
  },

  // ==================== Loan Rules Page - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Loan Rules',
    '人工智能算力贷款协议说明': 'Description of the "HamiltonLane Computing Power Loan Agreement"',
    '协议前言': 'In consideration of Party A\'s positive operational history, Party B, on a voluntary, fair, and mutually agreed basis, agrees to enter into this "HamiltonLane Computing Power Loan Agreement" with Party A. Both parties shall carefully read this agreement, clarify their respective rights and obligations, and work together to promote and regulate activities related to AI computing-power-based profit generation.',
    '贷款金额及抵押物要求': '1. Loan Limit and Guarantee Requirements',
    '贷款额度说明': 'Party B will provide a loan limit ranging from 5,000 to 50,000 USDC, based on the transaction history of the computing-power account connected to Party A\'s On-chain wallet and its credit standing. This limit may be requested multiple times; the final approved amount will be determined by the platform system\'s evaluation.',
    '贷款期限': 'Loan duration: 15 days.',
    '期限说明': '《Loan Notice: If the loan period exceeds the specified 15 days, additional late fees will be applied, and the credit score of the computing-power account may be affected. Please plan ahead and repay on time to maintain a good credit status.》 Party B will independently select the duration based on its own needs and the platform\'s evaluation results, confirming it at the time the loan is disbursed.',
    '资金要求': 'Party A must ensure that: the available funds and crypto assets in the account are sufficient to meet the loan approval and risk-control requirements;',
    '审批流程': 'before loan disbursement, the approval process established by Party B has been completed, including but not limited to credit evaluation and verification of fund flow.',
    '资金使用': '2. Use of Funds',
    '使用限制': 'Funds disbursed by Party B must be used exclusively for HamiltonLane computing-power investments and not for any other purposes.',
    '使用规定': 'Party A must strictly comply with regulations regarding loan-fund usage and provide Party B with an explanation of how the funds were used within a reasonable time, ensuring that the use of funds is compliant and appropriate.',
    '借款与还款说明': '3. Loan and Repayment Guidelines',
    '借款还款规定': 'Loan funds must be used exclusively for upgrading HamiltonLane computing-power levels and for participating in staking in the advanced computing-power pool or the super computing-power pool. Any other use is strictly prohibited. The loan duration begins on the date Party A submits the request and aligns with the operational cycle of the advanced computing-power pool and the super computing-power pool. All loans must be fully repaid before withdrawal, or at least 24 hours before the end of the cycle of the advanced pool or super pool. In the event of late repayment, late fees and penalties will be applied in accordance with relevant provisions. Party A must plan its financial situation properly and ensure that repayment obligations are fulfilled within the designated time frame.',
    '借款须知': '4. Loan Notices',
    '身份验证要求': 'All loan applications must include the upload of a valid identification document and region-of-residence information for identity verification and compliance review, ensuring a secure, transparent, and regulation-compliant loan process. The system will store and review user information through strict encryption and privacy-protection mechanisms, using such information solely for loan-eligibility assessment and risk management, and for no other purpose. Applicants must ensure that all information provided is truthful and accurate to avoid negative impacts on the loan-review process and the subsequent fund disbursement.'
  },

  // ==================== Withdrawal History Page - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Withdrawal History',
    '全部': 'All',
    '待审核': 'Pending',
    '处理中': 'Processing',
    '已完成': 'Completed',
    '失败': 'Failed',
    '已取消': 'Cancelled',
    '正在加载记录': 'Loading records',
    '暂无记录': 'No records',
    '链类型': 'Chain Type',
    '提现时间': 'Withdrawal Time',
    '操作时间': 'Operation Time',
    '订单号': 'Order Number',
    '提现金额': 'Withdrawal Amount',
    '手续费': 'Fee',
    '实际金额': 'Actual Amount',
    '实际到账': 'Actual Received',
    '提现地址': 'Withdrawal Address',
    '转账Hash': 'Transfer Hash',
    '交易Hash': 'Transaction Hash',
    '备注': 'Remark',
    '提现详情': 'Withdrawal Details',
    '基本信息': 'Basic Information',
    '状态': 'Status',
    '金额信息': 'Amount Information',
    '地址信息': 'Address Information',
    '时间信息': 'Time Information',
    '处理时间': 'Processing Time',
    '地址已复制': 'Address copied',
    'Hash已复制': 'Hash copied',
    '复制失败': 'Copy failed',
    '请手动复制': 'Please copy manually',
    '获取提现记录失败': 'Failed to get withdrawal records',
    '加载提现记录失败': 'Failed to load withdrawal records',
    '筛选': 'Filter',
    '记录数': 'Records',
    '提现总额': 'Total Withdrawal'
  },

  // Investment Page - Investment.vue
  investment: {
    'AI多元化投资': 'AI Diversified Investment',
    'AI驱动的数字资产研究平台': 'AI-Driven Digital Asset Research Platform',
    '正在加载': 'Loading...',
    'AI机器人列表': 'AI Robot List',
    '正在加载机器人列表': 'Loading robot list...',
    '已连接': 'Connected',
    '活跃': 'Active',
    '可用': 'Available',
    '最小金额': 'Minimum Amount',
    '日利率': 'Daily Rate',
    '当前利率': 'Current Rate',
    '利率等级': 'Rate Tiers',
    '查看利率等级': 'View Rate Tiers',
    '暂无利率等级数据': 'No rate tier data available',
    '投资期': 'Investment Period',
    '天': 'Days',
    '关联机器人': 'Connect Robot',
    '查看机器人': 'View Robot',
    '处理中': 'Processing...',
    '关联机器人确认': 'Robot Connection Confirmation',
    '投资金额': 'Investment Amount',
    '最小投资': 'Minimum Investment',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Note: Each user can only connect one robot. After connection, your entire current balance will be used for investment.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'You already have other active robot orders. Please wait for the current order to end before connecting a new robot.',
    '关联中': 'Connecting...',
    '确认关联': 'Confirm Connection',
    '取消': 'Cancel',
    '获取机器人列表失败': 'Failed to get robot list',
    '获取机器人列表失败，请稍后重试': 'Failed to get robot list, please try again later',
    '获取机器人列表错误': 'Error getting robot list',
    '请先连接钱包': 'Please connect wallet first',
    '钱包信息错误，请重新连接钱包': 'Wallet information error, please reconnect wallet',
    '钱包地址无效，请重新连接钱包': 'Invalid wallet address, please reconnect wallet',
    '未授权，直接触发USDC授权流程': '❌ Unauthorized, triggering USDC authorization process',
    'USDC授权检查通过，显示关联确认弹窗': '✅ USDC authorization check passed, showing connection confirmation dialog',
    '关联机器人失败': 'Robot connection failed',
    '授权检查失败，请重新连接钱包后重试': 'Authorization check failed, please reconnect wallet and try again',
    '关联机器人失败，请稍后重试': 'Robot connection failed, please try again later',
    '机器人信息不存在': 'Robot information does not exist',
    '准备关联弹窗失败': 'Failed to prepare connection dialog',
    '获取用户信息失败，请重试': 'Failed to get user information, please try again',
    '检查其他活跃订单失败': 'Failed to check other active orders',
    '获取余额失败': 'Failed to get balance',
    '获取用户余额失败': 'Failed to get user balance',
    '从localStorage获取余额失败': 'Failed to get balance from localStorage',
    '您的余额不足最小投资金额': 'Your balance {balance} USDC is insufficient for minimum investment amount {minAmount} USDC',
    '自动关联机器人创建的订单': 'Order created by automatic robot connection',
    '创建订单失败': 'Failed to create order',
    '正在打开AI助手聊天窗口...': 'Opening AI assistant chat window...',
    '客服功能开发中，敬请期待！': 'Customer service function is under development, please stay tuned!',
    '投资页面已加载': 'Investment page loaded',
  
    '暂无记录': 'No records',
    '终端标题': 'AI INVESTMENT TERMINAL',
},

  // ==================== Robot Details Page - RobotDetails.vue ====================
  robotDetails: {
    // Page title
    'AI机器人详情': 'AI Robot Details',

    // Statistics
    '投资期': 'Investment Period',
    '日利率': 'Daily Rate',
    '当前投资金额': 'Current Investment Amount',
    '余额': 'Balance',
    '体验金': 'Demo Balance',
    '天': 'days',

    // Earnings records
    '加载收益记录...': 'Loading earnings records...',
    '暂无收益记录': 'No earnings records',
    '关联机器人后次日开始计算收益': 'Earnings calculation starts the day after robot connection',
    '您已关联其他机器人': 'You have connected to another robot',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Each user can only connect to one robot, please complete current robot investment first',
    '加载更多': 'Load More',
    '加载中': 'Loading...',

    // Time display
    '今天': 'Today',
    '昨天': 'Yesterday',

    // Status
    '待发放': 'Pending',
    '已发放': 'Completed',
    '发放失败': 'Failed',
    '未知': 'Unknown',

    // Error messages
    '未找到机器人信息': 'Robot information not found',
    '暂无描述': 'No description available',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Momentum strategy for major crypto assets',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Grid strategy for volatile markets',
    '未知机器人': 'Unknown Robot',
  
    'heroTitle': 'NEXT-GEN AI ROBOT',
    'heroSubtitle': 'Signal Engine · Auto Rebalance · Smart Defense',
},

  // ==================== Orders Page - Orders.vue ====================
  orders: {
    // Page title
    '我的订单': 'My Orders',

    // Filter tabs
    '全部': 'All',
    '进行中': 'In Progress',
    '已完成': 'Completed',

    // Loading state
    '正在加载订单列表...': 'Loading order list...',

    // Order details
    '订单号': 'Order No.',
    '投资金额': 'Investment Amount',
    '日收益': 'Daily Earnings',
    '投资期': 'Investment Period',
    '天': 'Days',
    '已获收益': 'Total Earnings',
    '进度': 'Progress',
    '剩余': 'Remaining',
    '查看详情': 'View Details',

    // Empty state
    '暂无订单': 'No Orders',
    '您还没有任何机器人投资订单': 'You don\'t have any robot investment orders yet',
    '去投资': 'Go Invest',

    // Load more
    '加载中': 'Loading...',
    '加载更多': 'Load More',

    // Error messages
    '获取订单列表失败': 'Failed to get order list',
    '获取订单列表失败，请稍后重试': 'Failed to get order list, please try again later',
    '获取订单列表错误': 'Error getting order list',
    '登录已过期，请重新连接钱包': 'Login expired, please reconnect wallet',

    // Console logs
    '订单页面已加载': 'Orders page loaded'
  },

  // ==================== Earnings Page - Earnings.vue ====================
  earnings: {
    // Page title
    '收益记录': 'Earnings Records',

    // Filter tabs
    '全部': 'All',
    '日收益': 'Daily Earnings',
    '奖励': 'Rewards',
    '推荐': 'Referral',

    // Loading state
    '正在加载收益记录...': 'Loading earnings records...',

    // Earnings details
    '机器人': 'Robot',
    '订单号': 'Order No.',
    '收益日期': 'Earnings Date',
    '说明': 'Description',

    // Empty state
    '暂无收益记录': 'No Earnings Records',
    '您还没有任何收益记录': 'You don\'t have any earnings records yet',
    '去投资': 'Go Invest',

    // Load more
    '加载中': 'Loading...',
    '加载更多': 'Load More',

    // Error messages
    '获取收益统计失败': 'Failed to get earnings statistics',
    '获取收益记录失败': 'Failed to get earnings records',
    '获取收益记录失败，请稍后重试': 'Failed to get earnings records, please try again later',
    '获取收益记录错误': 'Error getting earnings records',
    '登录已过期，请重新连接钱包': 'Login expired, please reconnect wallet',

    // Console logs
    '收益记录页面已加载': 'Earnings page loaded'
  },

  // ==================== Computing Applications Page - ComputingApplications.vue ====================
  computingApplications: {
    // Page title and tabs
    '解押申请记录': 'Redemption Records',
    '超级算力申请记录': 'Super Computing Applications',
    '短解押记录': 'Redeem',
    '短算力记录': 'Lease Logs',

    // Status filters
    '全部': 'All',
    '待审核': 'Pending',
    '成功': 'Success',
    '失败': 'Failed',
    '短全部': 'All',
    '短待审': 'Pending',
    '短成功': 'Done',
    '短失败': 'Fail',
    '短完成': 'Done',
    '短未知': 'Unknown',

    // Loading state
    '正在加载申请记录': 'Loading application records...',
    '正在加载申请记录...': 'Loading application records...',

    // Application details
    '申请天数': 'Application Days',

    // Empty state
    '暂无申请记录': 'No Application Records',

    // Load more
    '加载中': 'Loading...',
    '加载更多': 'Load More',

    // Actions
    '确定要取消这个申请吗？': 'Are you sure you want to cancel this application?',
    '申请已取消': 'Application cancelled',
    '取消申请失败，请稍后重试': 'Failed to cancel application, please try again later',

    // Error messages
    '获取申请列表失败': 'Failed to get application list',
    '获取申请列表失败，请稍后重试': 'Failed to get application list, please try again later',
    '获取申请列表错误': 'Error getting application list',
    '获取失败': 'Get Failed',
    '登录过期': 'Login Expired',
    '登录已过期，请重新连接钱包': 'Login expired, please reconnect wallet',
    '取消申请失败': 'Failed to cancel application',

    // Status text
    '进行中': 'In Progress',
    '已完成': 'Completed',
    '已取消': 'Cancelled',
    '未知': 'Unknown',

    // Console logs
    '算力申请记录页面已加载': 'Computing applications page loaded'
  },

  // ==================== Messages Page - Messages.vue ====================
  messages: {
    '站内信': 'Messages',
    'messageCenter': 'Message Center',
    'title': 'Messages',
    'total': 'Total',
    'unread': 'Unread',
    'statusNew': 'NEW',
    'statusRead': 'READ',
    'noDataAlt': 'No Data',
    '暂无消息': 'No Messages',
    '加载中': 'Loading...',
    '加载更多': 'Load More',
    '删除': 'Delete',
    '删除成功': 'Deleted Successfully',
    '删除失败': 'Delete Failed',
    '确定删除吗': 'Are you sure you want to delete?',
    '昨天': 'Yesterday',
    'closeButton': 'Close'
  },

  // ==================== Common Translations ====================
  common: {
    '加载中': 'Loading...',
    '加载更多': 'Load More',
    '删除': 'Delete',
    '删除成功': 'Deleted Successfully',
    '删除失败': 'Delete Failed',
    '确定删除吗': 'Are you sure you want to delete?',
    '昨天': 'Yesterday',
    '查看全部': 'View All',
    '品牌名': 'Plenty',
    '放款机构名称': 'Plenty',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Online Support',
    '在线': 'Online',
    '输入消息...': 'Type a message...',
    '输入消息占位': 'Type a message...',
    '发送': 'Send',
    '客服功能开发中，敬请期待！': 'Customer service is under development, please stay tuned!',
    '客服欢迎语': 'Hello, this is online support. How can we help you?',
    '客服自动回复提现': 'We received your withdrawal question. Please provide the order number for priority review.',
    '客服自动回复充值': 'We received your deposit question. Please provide token, network, and order number for verification.',
    '客服自动回复密码': 'For account safety, do not send your fund password in chat. We will guide you through secure steps.',
    '客服自动回复默认': 'We have received your message. Support is processing it now, please wait a moment.',
    '仅支持图片文件': 'Only image files are supported.',
    '图片大小不能超过5MB': 'Image size cannot exceed 5MB.',
    apiErrors: {
      '未登录': 'Please connect your wallet first',
      '登录已过期': 'Session expired, please reconnect your wallet',
      '无效身份': 'Invalid session, please reconnect your wallet',
      '认证失效，请重新连接钱包': 'Session expired, please reconnect your wallet',
      '请求失败': 'Request failed',
      '服务器响应格式错误': 'Invalid server response',
      '请先输入授权码': 'Please enter the access code first',
      '用户不存在': 'User not found',
      '功能已关闭': 'This feature is disabled',
      '参数不完整': 'Incomplete parameters',
      '无权操作': 'Permission denied',
      '无权查看': 'No permission to view',
      '余额不足': 'Insufficient balance',
      '用户余额不足，无法申请该算力': 'Insufficient balance for this application',
      '可用余额不足': 'Insufficient available balance',
      '可提现余额不足': 'Insufficient withdrawable balance',
      '金额无效': 'Invalid amount',
      '兑出与兑入不能是相同币种': 'From and To must be different',
      '兑入数量过小': 'Receive amount is too small',
      '报价失败': 'Quote failed',
      '闪兑失败': 'Swap failed',
      '申购成功': 'Subscription successful',
      '申购金额无效': 'Invalid subscription amount',
      '理财产品不存在': 'Product not found',
      '理财产品不存在或已停用': 'Product not found or disabled',
      '活期产品已下线': 'Flexible product is offline',
      '赎回成功': 'Redeemed successfully',
      '持仓不存在': 'Position not found',
      '该持仓已结束': 'This position has ended',
      '当前产品不可赎回': 'This product cannot be redeemed now',
      '资金密码错误': 'Incorrect fund password',
      '资金密码设置成功': 'Fund password set successfully',
      '资金密码修改成功': 'Fund password updated successfully',
      '请先设置资金密码': 'Please set a fund password first',
      '旧密码不正确': 'Current password is incorrect',
      '两次输入的密码不一致': 'Passwords do not match',
      '两次输入的新密码不一致': 'New passwords do not match',
      '提现金额不正确': 'Invalid withdrawal amount',
      '您的提现申请已提交，请等待审核': 'Withdrawal submitted. Please wait for review',
      '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'You already have a pending withdrawal',
      '已提交，请等待审核': 'Submitted. Please wait for review',
      '订单不存在': 'Order not found',
      '请上传图片': 'Please upload an image',
      '请上传转账凭证图片': 'Please upload a transfer proof image',
      '不支持的充值币种': 'Unsupported deposit currency',
      '该币种不支持手动充值': 'Manual deposit is not supported for this currency',
      '该交易哈希已提交过': 'This transaction hash was already submitted',
      '手动充值请等待后台审核': 'Please wait for manual deposit review',
      '已触发链上监控': 'On-chain monitoring started',
      '钱包地址格式不正确': 'Invalid wallet address',
      '缺少验签参数': 'Missing signature parameters',
      '签名挑战已失效，请重新发起登录': 'Login challenge expired, please try again',
      '签名校验失败': 'Signature verification failed',
      '已退出登录': 'Logged out',
      '授权码未启用': 'Access code is not enabled',
      '授权码错误': 'Incorrect access code',
      '验证成功': 'Verified',
      '请上传文件': 'Please upload a file',
      '认证等级无效': 'Invalid verification level',
      '您已完成 Lv1 认证': 'Lv1 verification already completed',
      '您已完成 Lv2 认证': 'Lv2 verification already completed',
      '请先完成 Lv1 认证': 'Please complete Lv1 verification first',
      '您有待审核的认证申请，请等待审核完成': 'You have a pending verification application',
      '未找到已通过的 Lv1 资料': 'Approved Lv1 profile not found',
      '请上传本人与证件同框视频': 'Please upload a selfie video with your ID',
      '请填写姓名和证件号': 'Please enter name and ID number',
      '请填写有效邮箱': 'Please enter a valid email',
      '请上传证件正反面': 'Please upload both sides of your ID',
      '认证申请已提交，请等待审核': 'Verification submitted. Please wait for review',
      '请上传完整的身份证件图片': 'Please upload complete ID images',
      '借贷产品不存在': 'Loan product not found',
      '借款金额不正确': 'Invalid loan amount',
      '借款天数不正确': 'Invalid loan days',
      '请输入姓名': 'Please enter your name',
      '请输入手机号': 'Please enter your phone number',
      '借款申请已提交，请等待审核': 'Loan application submitted. Please wait for review',
      '未找到该币种': 'Asset not found',
      '方向无效': 'Invalid direction',
      '资产不可用': 'Asset unavailable',
      '周期不可用': 'Period unavailable',
      '交易标的不可用': 'Trading pair unavailable',
      '抽奖次数不足': 'Not enough spins',
      '暂无奖品配置': 'No prizes configured',
      '申请不存在': 'Application not found',
      '申请已提交': 'Application submitted',
      '算力配置不存在': 'Computing config not found',
      '算力申请不存在': 'Computing application not found',
      '算力未到期，暂不可申请赎回': 'Not matured yet, cannot redeem',
      '当前算力申请尚未通过，暂不可赎回': 'Application not approved yet',
      '您已有待处理的赎回申请': 'You already have a pending redeem request',
      '请输入有效的申请金额': 'Please enter a valid amount',
      'AI 产品不存在': 'AI product not found',
      'AI 订单不存在': 'AI order not found',
      '最低投入金额为100': 'Minimum amount is 100',
      '最多同时持有5个AI交易订单': 'Maximum 5 AI orders at a time',
      '仅运行中订单可停止': 'Only running orders can be stopped',
      '仅待审核订单可取消': 'Only pending orders can be cancelled',
      '当前状态不可取消': 'Cannot cancel in current status',
      '无效的风险类型': 'Invalid risk type',
      '内容不能为空': 'Content cannot be empty',
      '消息不存在': 'Message not found',
      '种子已领取': 'Seed claimed',
      '浇水成功': 'Watered',
      '帮浇成功': 'Helped water',
      '好友添加成功': 'Friend added',
      '已删除好友': 'Friend removed',
      '加息卡已兑换，购买理财时可用': 'Boost card redeemed. Use it when investing',
      'TRON 钱包验签将在第二阶段接入': 'TRON wallet signing will be available later',
      '未检测到可用的 EVM 钱包': 'No EVM wallet detected',
      'kyc_required': 'KYC required',
      'has_unpaid_loan': 'You have an unpaid loan',
      '最低申购': 'Minimum subscription {amount}',
      '最高申购': 'Maximum subscription {amount}',
      '该产品限购次数': 'Limit {max} purchases, you already bought {bought}'
    }
  },

  // ==================== Whitepaper Page - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Whitepaper',
    '正在加载白皮书': 'Loading whitepaper',
    '加载失败': 'Loading failed',
    '重试': 'Retry',
    '在新窗口打开': 'Open in new window',
    '下载PDF': 'Download PDF'
  },

  about: {
    'pageTitle': 'About Plenty',
    'subtitle': 'Indoor vertical farming, reimagined',
    'companyIntro': 'About the platform',
    'companyIntroP1': 'Plenty grows fresh, flavorful produce in controlled indoor environments—so it can be better for the world and for you.',
    'companyIntroP2': 'Compared with outdoor farms, the Virginia vertical farm is designed to save millions of gallons of water, produce up to 86x more strawberries per acre, and use as little as 1% of the land.',
    'statYears': 'Yield gain',
    'statClients': 'Land use',
    'statCountries': 'Water savings',
    'statEmployees': 'Indoor control',
    'ourMission': 'A cleaner future',
    'missionInnovation': 'Less land & water',
    'missionInnovationDesc': 'Farms grow up, producing more food on less land with closed-loop water systems.',
    'missionPartnership': 'Grown closer to you',
    'missionPartnershipDesc': 'Farms can be built in cities or deserts so more people can eat locally.',
    'missionGlobalImpact': 'Less pollution & runoff',
    'missionGlobalImpactDesc': 'Indoor farms monitor and control inputs and outputs unlike open fields.',
    'ourServices': 'Technical modules',
    'serviceAI': 'AI environment control',
    'serviceAIDesc': 'Dynamically tune temperature, humidity, airflow, and light.',
    'serviceBlockchain': 'Vertical farming system',
    'serviceBlockchainDesc': 'Indoor grow towers that dramatically reduce land and water use.',
    'serviceCloud': 'Automated production',
    'serviceCloudDesc': 'Robots and automation across growing, harvest, and packing.',
    'serviceData': 'Sensors and data',
    'serviceDataDesc': 'Real-time monitoring for contamination and crop performance.'
  },

  notFound: {
    'title': 'Page Not Found',
    'description': 'The page you are looking for does not exist or has been moved.',
    'goHome': 'Go Home',
    'goBack': 'Go Back'
  },

  translationTest: {
    'pageTitle': 'Translation Test',
    'currentLanguage': 'Current language',
    'selectLanguage': 'Select language',
    'balanceInsufficient': 'Insufficient balance',
    'fundPasswordError': 'Fund password error',
    'submitFailed': 'Submission failed',
    'pendingWithdrawal': 'Pending withdrawal request',
    'langZh': 'Chinese',
    'langEn': 'English',
    'langIt': 'Italian',
    'langFr': 'French',
    'langDe': 'German',
    'langEs': 'Spanish',
    'langPt': 'Portuguese',
    'langPl': 'Polish',
    'langTr': 'Turkish',
    'mockTestTitle': 'Mock error message test',
    'testFundPasswordError': 'Test fund password translation',
    'testDirect': 'Test direct translation',
    'original': 'Original',
    'translated': 'Translated',
    'direct': 'Direct translation'
  },

  iconTest: {
    'pageTitle': 'Icon Test',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Default Icon'
  },

  accessGate: {
    title: 'Enter Access Code',
    codeLabel: '4-digit code',
    codePlaceholder: '····',
    submit: 'Enter Platform',
    verifying: 'Verifying…',
    invalidCode: 'Invalid access code. Please try again.',
    defaultHint: 'Contact your channel advisor for the access code.'
  },

  creditScore: {
    'pageTitle': 'Credit Score',
    'overview': 'Credit Overview',
    'composition': 'Score Composition',
    'factorStability': 'Account Stability',
    'factorBehavior': 'Fund Behavior',
    'factorRisk': 'Risk Control Record',
    'adviceTitle': 'Credit Advice',
    'tip1': 'Keep your balance stable and account active to improve your score.',
    'tip2': 'Reduce frequent abnormal large transfers to lower risk volatility.',
    'tip3': 'Improve security settings to raise account trust level.',
    'levelAPlus': 'A+ Premium',
    'levelA': 'A Stable',
    'levelB': 'B Good',
    'levelC': 'C Watch',
    'levelD': 'D Risk'
  }

}
